import React from "react";

function TopScorer({ name, points }) {
  return (
    <>
      <div className="mb-[18px] flex h-[98px] w-[98px] items-center justify-center rounded-full bg-[var(--color-green)]">
        <p className="mb-0 text-[60px] font-bold leading-none">1</p>
      </div>
      <p className="mb-2 text-[26px] font-bold leading-none">{name}</p>
      <p className="mb-0 text-[26px] font-bold leading-none text-[var(--color-green)]">
        {points} poäng
      </p>
    </>
  );
}

export default TopScorer;
